import { useEffect, useState } from "react";
import { subscribeToCrossTabDataChanges } from "../utils/crossTabDataSync";

export default function useCrossTabDataRefreshToken(shouldRefresh) {
  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    let refreshTimerId = null;

    const unsubscribe = subscribeToCrossTabDataChanges((event) => {
      if (typeof shouldRefresh === "function" && !shouldRefresh(event)) {
        return;
      }

      if (refreshTimerId) {
        window.clearTimeout(refreshTimerId);
      }

      refreshTimerId = window.setTimeout(() => {
        setRefreshToken((value) => value + 1);
      }, 300);
    });

    return () => {
      if (refreshTimerId) {
        window.clearTimeout(refreshTimerId);
      }
      unsubscribe();
    };
  }, [shouldRefresh]);

  return refreshToken;
}
